export default (function (_a) {
    var baseUnit = _a.theme.constants.SIZE_SUB_UNIT, width = _a.width;
    if (typeof width === "object") {
        var _b = width.min, min = _b === void 0 ? "" : _b, _c = width.max, max = _c === void 0 ? "" : _c;
        return "\n      " + (min && "min-width: " + (typeof min === "number" ? baseUnit * min + "px" : min) + ";") + "\n      " + (max && "max-width: " + (typeof max === "number" ? baseUnit * max + "px" : max) + ";") + "\n    ";
    }
    return width && "width: " + (typeof width === "number" ? baseUnit * width + "px" : width) + ";";
});
